<template>
  <div id="exam-choice-box">
    <v-container grid-list-xl v-show="!finishExam">
      <v-layout align-center justify-center row wrap>
        <v-flex xs10>
          <div class="title">ข้อที่</div>
          <div class="display-2 my-2">{{ start + 1 }} / {{ exams.length }}</div>
        </v-flex>
        <v-flex v-if="exams[start]" xs10>
          <div class="title">{{ exams[start].proposition }}</div>
        </v-flex>
        <v-flex
          :key="choice.idx"
          @click="setSelectedChoice(choice.idx)"
          class="mouse-pointer"
          my-1
          style="background:#F2F2F2"
          v-for="choice in choices"
          xs10
        >
          <v-checkbox
            :value="choice.idx"
            class="mt-0"
            color="primary"
            hide-details
            single-line
            v-model="selectedChoice"
          >
            <template v-slot:label>
              <div class="subheading ml-3 black--text">{{ choice.examText }}</div>
            </template>
          </v-checkbox>
        </v-flex>
        <v-flex class="btn-bottom" pt-0 px-0 xs10>
          <v-btn
            :disabled="selectedChoice ? false : true"
            @click="doAnswer()"
            block
            class="subheading"
            color="#06E59F"
            depressed
            large
            v-if="start < exams.length"
            >ส่งคำตอบ</v-btn
          >
        </v-flex>
      </v-layout>
    </v-container>
    <v-container grid-list-xl v-show="finishExam">
      <div class="resultContainer">
        <v-layout align-center fill-height justify-center row>
          <v-flex px-0 xs10>
            <div class="title">คุณตอบถูก</div>
            <div class="display-2 my-3">{{ checkAnswers() }} / {{ exams.length }}</div>
            <v-btn
              @click="
                $router.push({ name: 'knowledge-detail', params: $route.params.knowledgeTitle })
              "
              class="subheading mt-5"
              color="#06E59F"
              depressed
              large
              >กลับไปหน้าหลัก</v-btn
            >
          </v-flex>
        </v-layout>
      </div>
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'exam-choice-box',
  props: {
    exams: {
      type: Array
    }
  },
  data() {
    return {
      start: 0,
      selectedChoice: '',
      choices: [],
      answers: [],
      finishExam: false
    }
  },
  watch: {
    exams() {
      this.getChoice(this.exams[this.start].idx)
    }
  },
  methods: {
    setSelectedChoice(selceted) {
      this.selectedChoice = selceted
    },
    checkAnswers() {
      return this.answers.reduce(
        (sumCorrect, currentAnswer) => parseInt(sumCorrect) + parseInt(currentAnswer.answer),
        0
      )
    },
    doAnswer() {
      if (this.start < this.exams.length) {
        let getAnswer = this.choices
          .filter(item => item.idx == this.selectedChoice)
          .map(item => item.correct)
          .toString()
        this.answers.push({
          choiceId: this.selectedChoice,
          answer: getAnswer
        })
        this.start += 1
        // clear selected
        this.selectedChoice = ''
        if (this.start !== this.exams.length) {
          this.getChoice(this.exams[this.start].idx)
        } else {
          // finish exam
          this.checkAnswers()
          this.finishExam = !this.finishExam
        }
      }
    },
    async getChoice(examId) {
      try {
        const response = await this.axios.get(`portal/choice/${examId}`)
        this.choices = _.shuffle(response.data)
      } catch (error) {
        throw new Error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.resultContainer {
  height: 450px;
}
.btn-bottom {
  // position: relative;
  // bottom: 10px;
  // width: 80%;
}
</style>
